import React from "react";
import useBlanketBondForm from "../../../features/bonds/blanket/hooks/useBlanketBondForm";
import BondWizardPageShell from "./BondWizardPageShell";
import { bondWizardPageConfig } from "./bondWizardPageConfig";

const VermostBlanketBondRequestForm = () => {
  const form = useBlanketBondForm();
  return (
    <BondWizardPageShell config={bondWizardPageConfig.blanket} form={form} />
  );
};

export default VermostBlanketBondRequestForm;
